// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"bc9772c2","126":"c35154a6","147":"842ed15a","171":"c4029f08","374":"9f1d6a61","388":"0c4d6ddc","466":"650fa23e","507":"60f6f502","780":"d1323891"}[chunkId] + ".chunk.js";
};